import { BehaviorSubject, Subject, Observable } from 'rxjs';

import { SnSearchbarOptionConfig } from '@lib/ui/searchbar';

export class SnLayoutAppbarSearchReference {
  private readonly _change$: BehaviorSubject<string> = new BehaviorSubject(null);
  private readonly _options$: BehaviorSubject<SnSearchbarOptionConfig[]> = new BehaviorSubject([]);
  private readonly _submit$: Subject<string> = new Subject();

  private readonly _activationChange$: BehaviorSubject<boolean> = new BehaviorSubject(false);

  constructor() {}

  get change$(): Observable<string> {
    return this._change$.asObservable();
  }

  get options$(): Observable<SnSearchbarOptionConfig[]> {
    return this._options$.asObservable();
  }

  get activationChange$(): Observable<boolean> {
    return this._activationChange$.asObservable();
  }

  set value(value: string) {
    this._change$.next(value);
  }
  get value(): string {
    return this._change$.value;
  }

  get isActive(): boolean {
    return this._activationChange$.value;
  }

  get submit$(): Observable<string> {
    return this._submit$.asObservable();
  }

  public onDestroy(): void {
    this._change$.complete();
    this._activationChange$.complete();
  }

  public activate(): void {
    this.toggleActivation(true);
  }

  public deactivate(): void {
    this.toggleActivation(false);

    this._change$.next(null);

    this.clearOptions();
  }

  public toggleActivation(active: boolean = !this.isActive): void {
    if (this.isActive !== active) {
      this._activationChange$.next(active);
    }
  }

  public setOptions(options: SnSearchbarOptionConfig[]): void {
    this._options$.next(options);
  }

  public clearOptions(): void {
    this._options$.next([]);
  }

  public onSearch(value: string): void {
    this._change$.next(value);
  }

  public onSubmit(value: string): void {
    this._submit$.next(value);
  }
}
